import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { UsersUIProvider } from './UsersContextProvider';

const UsersList = React.lazy(() => import('./Users'));

function Users(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست کاربران</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <UsersUIProvider>
          <UsersList {...props} />
        </UsersUIProvider>
      </Suspense>
    </Page>
  );
}

export default Users;
